import { Route, Routes } from 'react-router-dom';
import { AuthGuard } from './components/AuthGuard';
import MainApp from './components/MainApp';
import Navigation from './components/Navigation';
import { AppProvider } from './contexts/AppContext';
import AISectionsTestPage from './pages/AISectionsTestPage';
import CTATestPage from './pages/CTATestPage';
import FormAssistantTestPage from './pages/FormAssistantTestPage';
import FormTestPage from './pages/FormTestPage';
import PostConversionTestPage from './pages/PostConversionTestPage';
import StatusIndicatorPage from './pages/StatusIndicatorPage';

function App() {
    return (
        <AuthGuard>
            <AppProvider>
                <div className="relative">
                    {/* Navigation component - only shows on test pages */}
                    <Navigation />

                    <Routes>
                        {/* Main app (existing functionality) */}
                        <Route path="/" element={<MainApp />} />

                        {/* CTA test page */}
                        <Route path="/cta-test" element={<CTATestPage />} />

                        {/* Form test pages with dynamic form type */}
                        <Route path="/form-test/:formType" element={<FormTestPage />} />

                        {/* Default form test page */}
                        <Route path="/form-test" element={<FormTestPage />} />

                        {/* AI Sections test page */}
                        <Route path="/ai-sections" element={<AISectionsTestPage />} />

                        {/* Form assistant test page */}
                        <Route path="/form-assistant" element={<FormAssistantTestPage />} />

                        {/* Post-conversion qualification test page (simulates thank-you page) */}
                        <Route path="/thank-you" element={<PostConversionTestPage />} />

                        {/* Backend /status indicator (Sentry-monitored deep health probe) */}
                        <Route path="/status" element={<StatusIndicatorPage />} />
                    </Routes>
                </div>
            </AppProvider>
        </AuthGuard>
    );
}

export default App;
